import { render, staticRenderFns } from "./viewReceive.vue?vue&type=template&id=47d6090a&scoped=true&"
import script from "./viewReceive.vue?vue&type=script&lang=js&"
export * from "./viewReceive.vue?vue&type=script&lang=js&"
import style0 from "./viewReceive.vue?vue&type=style&index=0&id=47d6090a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6090a",
  null
  
)

export default component.exports